export default __webpack_public_path__ + "static/realWorldImg2-b8277f7c0f2514d3e106678ad7536893.png";